import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface MonthlyCommissionData {
  year: number | null;
  month: string;
  total_transactions: number;
  total_commission: number;
}

interface MonthlyCommissionResponse {
  data: MonthlyCommissionData[];
}

const useFetchTotalTransaction = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [totalTransaction, setTotalTransaction] = useState<MonthlyCommissionData[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined | null>(null);

  useEffect(() => {
    const fetchMonthlyCommission = async () => {
      try {
        const tk = await getAccessTokenSilently();
 
        const response = await axios.get<MonthlyCommissionResponse>(
          `${apiUrl}/api/v1/admin/profile/transaction/monthly`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );
        setTotalTransaction(response.data.data);
      } catch (err) {
        setError("Error fetching monthly commission");
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchMonthlyCommission();
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return { totalTransaction, loading, error };
};

export default useFetchTotalTransaction;
